<app-landing-page-register
    title="Get started for free now"
    subtitle="Simply sign up and give traigo a try!"
    successTitle="Thank you for registering on traigo!"
    successSubtitle="What happens next?"
></app-landing-page-register>
